import Typography from '@mui/material/Typography';
import React from 'react';
import Link from '@mui/material/Link';
import RoleBadges from '../General/RoleBadges';

const ProfileName = props => {
  const { username, displayName, roles } = props.author;

  if (props.authorNotClickable)
    return (
      <span className="textPrimary">
        <strong>{displayName}</strong>
      </span>
    );
  return (
    <>
      <Link color="textPrimary" href={`/@${username}`} legacyBehavior>
        <a className="hoverline">
          <div className={props.noInline ? undefined : 'd-inline'}>
            <strong>
              {username === displayName ? `@${username}` : displayName}
            </strong>
          </div>
          {username !== displayName && (
            <Typography
              color="textSecondary"
              variant="subtitle2"
              display="inline"
            >
              {' '}
              @{username}
            </Typography>
          )}
        </a>
      </Link>
      <RoleBadges roles={roles} />
    </>
  );
};

export default ProfileName;
